// extracted by mini-css-extract-plugin
export var baseButton = "_va-0";
export var controlsArrowKeys = "_va-1";
export var controlsResetButton = "_va-2";
export var lightGameButton = "_va-4 _va-0";
export var playAgainButton = "_va-5 _va-0";
export var startGameButton = "_va-3 _va-0";